import { makeStyles } from "@mui/styles"

export default makeStyles({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  smMargin: {
    margin: 5,
  },
  actionDiv: {
    textAlign: 'center',
  },
});